module.exports = __webpack_public_path__ + "media/images/logo-eb1376bea1149fe8e1982665b2982f93.png";